import { useState, useRef, useEffect } from "react";
import { S, NAVY, GREEN_BG, BEIGE, SLATE, fmtVal, fmt, sameId } from "../constants";
import { AttachmentsPanel } from "./shared";

// eslint-disable-next-line no-unused-vars
export function LeadFormModal({ newLead, setNewLead, stages, leadSources, services, users, setShowAddLead, handleAddLead }) {
  return (
    <div style={S.modal}><div style={S.modalBox}>
      <h3 style={{ margin: "0 0 24px", fontFamily: "Merriweather,serif", fontSize: 20, color: NAVY }}>Add New Lead</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div style={{ gridColumn: "1/-1" }}><label style={S.label}>Club Name *</label><input value={newLead.clubName} onChange={e => setNewLead({ ...newLead, clubName: e.target.value })} placeholder="Oakmont Country Club" style={S.input} /></div>
        <div><label style={S.label}>Contact Name *</label><input value={newLead.contactName} onChange={e => setNewLead({ ...newLead, contactName: e.target.value })} placeholder="James Whitfield" style={S.input} /></div>
        <div><label style={S.label}>Email Address *</label><input value={newLead.email} onChange={e => setNewLead({ ...newLead, email: e.target.value })} placeholder="james@club.com" style={S.input} /></div>
        <div><label style={S.label}>Phone Number</label><input value={newLead.phone} onChange={e => setNewLead({ ...newLead, phone: e.target.value })} placeholder="+1-404-555-0000" style={S.input} /></div>
        <div><label style={S.label}>Title / Role</label><input value={newLead.title} onChange={e => setNewLead({ ...newLead, title: e.target.value })} placeholder="Membership Director" style={S.input} /></div>
        <div><label style={S.label}>Lead Status</label><select value={newLead.stage} onChange={e => setNewLead({ ...newLead, stage: e.target.value })} style={S.input}>{stages.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
        <div><label style={S.label}>Lead Source</label><select value={newLead.source} onChange={e => setNewLead({ ...newLead, source: e.target.value })} style={S.input}><option value="">Select source...</option>{leadSources.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
        <div><label style={S.label}>Service Interest</label><select value={newLead.service} onChange={e => setNewLead({ ...newLead, service: e.target.value })} style={S.input}><option value="">Select service...</option>{services.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
        <div><label style={S.label}>Monthly Value ($)</label><input type="number" value={newLead.value} onChange={e => setNewLead({ ...newLead, value: e.target.value })} placeholder="349.99" style={S.input} /></div>
        <div><label style={S.label}>Follow-up Date</label><input type="date" value={newLead.followUp} onChange={e => setNewLead({ ...newLead, followUp: e.target.value })} style={S.input} /></div>
        <div style={{ gridColumn: "1/-1" }}><label style={S.label}>Assign To</label><select value={newLead.assignedTo} onChange={e => setNewLead({ ...newLead, assignedTo: e.target.value })} style={S.input}><option value="">— Unassigned —</option>{users.map(u => <option key={u.id} value={u.id}>{u.name} · {u.role}</option>)}</select></div>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 24, justifyContent: "flex-end" }}><button onClick={() => setShowAddLead(false)} style={S.btnGhost}>Cancel</button><button onClick={handleAddLead} style={S.btnPrimary}>Add Lead</button></div>
    </div></div>
  );
}

// eslint-disable-next-line no-unused-vars
export function ClientFormModal({ newClient, setNewClient, leadSources, services, clientStatuses, users, setShowAddClient, handleAddClient }) {
  return (
    <div style={S.modal}><div style={S.modalBox}>
      <h3 style={{ margin: "0 0 24px", fontFamily: "Merriweather,serif", fontSize: 20, color: NAVY }}>Add New Client</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div style={{ gridColumn: "1/-1" }}><label style={S.label}>Club Name *</label><input value={newClient.clubName} onChange={e => setNewClient({ ...newClient, clubName: e.target.value })} placeholder="Oakmont Country Club" style={S.input} /></div>
        <div><label style={S.label}>Contact Name *</label><input value={newClient.contactName} onChange={e => setNewClient({ ...newClient, contactName: e.target.value })} placeholder="James Whitfield" style={S.input} /></div>
        <div><label style={S.label}>Email Address *</label><input value={newClient.email} onChange={e => setNewClient({ ...newClient, email: e.target.value })} placeholder="james@club.com" style={S.input} /></div>
        <div><label style={S.label}>Phone Number</label><input value={newClient.phone} onChange={e => setNewClient({ ...newClient, phone: e.target.value })} placeholder="+1-404-555-0000" style={S.input} /></div>
        <div><label style={S.label}>Title / Role</label><input value={newClient.title} onChange={e => setNewClient({ ...newClient, title: e.target.value })} placeholder="Membership Director" style={S.input} /></div>
        <div><label style={S.label}>Service</label><select value={newClient.service} onChange={e => setNewClient({ ...newClient, service: e.target.value })} style={S.input}><option value="">Select service...</option>{services.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
        <div><label style={S.label}>Lead Source</label><select value={newClient.source} onChange={e => setNewClient({ ...newClient, source: e.target.value })} style={S.input}><option value="">Select source...</option>{leadSources.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
        <div><label style={S.label}>Status</label><select value={newClient.status} onChange={e => setNewClient({ ...newClient, status: e.target.value })} style={S.input}>{clientStatuses.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
        <div><label style={S.label}>Monthly Value ($)</label><input type="number" value={newClient.value} onChange={e => setNewClient({ ...newClient, value: e.target.value })} placeholder="349.99" style={S.input} /></div>
        <div><label style={S.label}>Start Date</label><input type="date" value={newClient.startDate} onChange={e => setNewClient({ ...newClient, startDate: e.target.value })} style={S.input} /></div>
        <div style={{ gridColumn: "1/-1" }}><label style={S.label}>Renewal Date</label><input type="date" value={newClient.renewalDate} onChange={e => setNewClient({ ...newClient, renewalDate: e.target.value })} style={S.input} /></div>
        <div style={{ gridColumn: "1/-1" }}><label style={S.label}>Assign To</label><select value={newClient.assignedTo} onChange={e => setNewClient({ ...newClient, assignedTo: e.target.value })} style={S.input}><option value="">— Unassigned —</option>{users.map(u => <option key={u.id} value={u.id}>{u.name} · {u.role}</option>)}</select></div>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 24, justifyContent: "flex-end" }}><button onClick={() => setShowAddClient(false)} style={S.btnGhost}>Cancel</button><button onClick={handleAddClient} style={S.btnPrimary}>Add Client</button></div>
    </div></div>
  );
}

// eslint-disable-next-line no-unused-vars
export function ConvertModal({ selectedLead, convertData, setConvertData, clientStatuses, setShowConvert, handleConvert }) {
  return (
    <div style={S.modal}><div style={{ ...S.modalBox, width: 460 }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 20 }}><div style={{ width: 44, height: 44, background: GREEN_BG, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>⭐</div><div><h3 style={{ margin: 0, fontFamily: "Merriweather,serif", fontSize: 18, color: NAVY }}>Create New Customer</h3><p style={{ margin: "4px 0 0", fontSize: 13, color: SLATE }}>{selectedLead && selectedLead.clubName} will be moved to your Clients list.</p></div></div>
      <div style={{ background: BEIGE, borderRadius: 8, padding: "14px 16px", marginBottom: 20 }}><div style={{ display: "flex", gap: 24 }}><div><div style={{ fontSize: 11, color: SLATE, marginBottom: 2 }}>Club</div><div style={{ fontWeight: 700, color: NAVY, fontSize: 13 }}>{selectedLead && selectedLead.clubName}</div></div><div><div style={{ fontSize: 11, color: SLATE, marginBottom: 2 }}>Service</div><div style={{ fontWeight: 700, color: NAVY, fontSize: 13 }}>{selectedLead && (selectedLead.service || "—")}</div></div><div><div style={{ fontSize: 11, color: SLATE, marginBottom: 2 }}>MRR</div><div style={{ fontWeight: 700, color: NAVY, fontSize: 13 }}>{selectedLead && selectedLead.value ? fmtVal(selectedLead.value) : "—"}</div></div></div></div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 16 }}><div><label style={S.label}>Start Date</label><input type="date" value={convertData.startDate} onChange={e => setConvertData({ ...convertData, startDate: e.target.value })} style={S.input} /></div><div><label style={S.label}>Renewal Date</label><input type="date" value={convertData.renewalDate} onChange={e => setConvertData({ ...convertData, renewalDate: e.target.value })} style={S.input} /></div><div style={{ gridColumn: "1/-1" }}><label style={S.label}>Client Status</label><select value={convertData.status} onChange={e => setConvertData({ ...convertData, status: e.target.value })} style={S.input}>{clientStatuses.map(s => <option key={s} value={s}>{s}</option>)}</select></div></div>
      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}><button onClick={() => setShowConvert(false)} style={S.btnGhost}>Cancel</button><button onClick={handleConvert} style={S.btnGreen}>Confirm & Create Customer</button></div>
    </div></div>
  );
}

// eslint-disable-next-line no-unused-vars
export function ActivityModal({ newActivity, setNewActivity, setShowAddActivity, handleAddActivity }) {
  return (
    <div style={S.modal}><div style={{ ...S.modalBox, width: 440 }}>
      <h3 style={{ margin: "0 0 20px", fontFamily: "Merriweather,serif", fontSize: 18, color: NAVY }}>Log Activity</h3>
      <div style={{ marginBottom: 14 }}><label style={S.label}>Activity Type</label><select value={newActivity.type} onChange={e => setNewActivity({ ...newActivity, type: e.target.value })} style={S.input}>{["Phone Call", "Email", "Demo", "Meeting", "Tour", "Text Message", "Note", "Other"].map(t => <option key={t} value={t}>{t}</option>)}</select></div>
      <div style={{ marginBottom: 20 }}><label style={S.label}>Notes</label><textarea value={newActivity.content} onChange={e => setNewActivity({ ...newActivity, content: e.target.value })} placeholder="Describe the activity, outcome, and any follow-up needed..." rows={5} style={{ ...S.input, resize: "vertical" }} /></div>
      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}><button onClick={() => setShowAddActivity(false)} style={S.btnGhost}>Cancel</button><button onClick={handleAddActivity} style={S.btnPrimary}>Save Activity</button></div>
    </div></div>
  );
}

const replaceVars = (text, record, user) => {
  if (!text) return text;
  return text
    .replace(/\{\{clubName\}\}/g,     record?.clubName    || record?.name || "")
    .replace(/\{\{contactName\}\}/g,  record?.contactName || record?.name || "")
    .replace(/\{\{senderName\}\}/g,   user?.name          || user?.full_name || "")
    .replace(/\{\{renewalDate\}\}/g,  record?.renewalDate ? fmt(record.renewalDate) : "");
};

// eslint-disable-next-line no-unused-vars
export function EmailComposeModal({ lead, client, currentUser, onClose, showToast, saveLeads, saveClients, leads, clients, templates = [], signature = "" }) {
  const record = lead || client;
  const [to, setTo] = useState(record?.email || "");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [showCcBcc, setShowCcBcc] = useState(false);
  const [subject, setSubject] = useState("");
  const [purpose, setPurpose] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [sending, setSending] = useState(false);
  const [drafting, setDrafting] = useState(false);
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [linkText, setLinkText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const editorRef = useRef(null);
  const savedSelectionRef = useRef(null);
  const fileInputRef = useRef(null);
  const colorInputRef = useRef(null);

  const EMOJIS = ["😊","👍","🎉","✅","📧","📞","🏌️","⭐","🤝","💼","📅","🔔","💡","🏆","👋","🙏","📝","💰","🎯","✨"];

  // Initialize editor with signature
  useEffect(() => {
    if (editorRef.current && signature) {
      editorRef.current.innerHTML = `<br><br>-- <br>${signature.replace(/\n/g, "<br>")}`;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveSelection = () => {
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) savedSelectionRef.current = sel.getRangeAt(0).cloneRange();
  };

  const restoreSelection = () => {
    const sel = window.getSelection();
    if (savedSelectionRef.current && sel) {
      sel.removeAllRanges();
      sel.addRange(savedSelectionRef.current);
    }
  };

  const exec = (cmd, value = null) => {
    editorRef.current?.focus();
    document.execCommand(cmd, false, value);
  };

  const insertLink = () => {
    restoreSelection();
    if (linkUrl) {
      const display = linkText || linkUrl;
      exec("insertHTML", `<a href="${linkUrl}" target="_blank" rel="noopener noreferrer">${display}</a>`);
    }
    setShowLinkInput(false);
    setLinkUrl("");
    setLinkText("");
  };

  const insertEmoji = (emoji) => {
    editorRef.current?.focus();
    exec("insertText", emoji);
    setShowEmojiPicker(false);
  };

  const handleFileAttach = (e) => {
    const files = Array.from(e.target.files || []);
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setAttachments(prev => [...prev, {
          id: Date.now() + Math.random(),
          name: file.name,
          size: file.size,
          type: file.type,
          data: ev.target.result
        }]);
      };
      reader.readAsDataURL(file);
    });
    e.target.value = "";
  };

  const ToolBtn = ({ cmd, value, title, children, onClick, active }) => (
    <button
      title={title}
      onMouseDown={e => { e.preventDefault(); onClick ? onClick() : exec(cmd, value); }}
      style={{
        background: active ? "#e8edf5" : "none",
        border: "none",
        borderRadius: 4,
        padding: "3px 7px",
        cursor: "pointer",
        fontSize: 13,
        color: NAVY,
        fontWeight: cmd === "bold" ? 700 : 400,
        fontStyle: cmd === "italic" ? "italic" : "normal",
        textDecoration: cmd === "underline" ? "underline" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 28,
        height: 28,
      }}
    >{children}</button>
  );

  const Divider = () => <div style={{ width: 1, height: 20, background: "#ddd", margin: "0 2px" }} />;

  const draftWithAI = async () => {
    setDrafting(true);
    try {
      const context = lead
        ? `Club/Prospect: ${record?.clubName || record?.name}, Contact: ${record?.contactName || ""}, Stage: ${record?.stage || ""}, Service: ${record?.service || ""}`
        : `Client: ${record?.clubName || record?.name}, Contact: ${record?.contactName || ""}, Status: ${record?.status || ""}`;
      const purposeLine = purpose ? `\nPurpose of this email: ${purpose}` : "";
      const resp = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514",
          max_tokens: 1000,
          messages: [{ role: "user", content: `You are a membership sales professional. Write a complete, ready-to-send email with a greeting, 2-3 short paragraphs, and a professional sign-off. Do not include a subject line.\n\n${context}${purposeLine}` }]
        })
      });
      const data = await resp.json();
      const text = data.content?.[0]?.text || "";
      if (editorRef.current) {
        editorRef.current.innerHTML = text
          ? text.replace(/\n/g, "<br>")
          : "Could not generate draft. Please type your message.";
      }
    } catch (err) {
      console.error("AI draft error:", err);
      if (editorRef.current) editorRef.current.innerHTML = "Could not generate draft. Please type your message.";
    }
    setDrafting(false);
  };

  const send = async () => {
    const bodyHtml = editorRef.current?.innerHTML || "";
    const bodyText = editorRef.current?.innerText || "";
    if (!to || !subject || !bodyText.trim()) { showToast("Please fill in all fields", "error"); return; }
    setSending(true);

    const replace = (text) => (text || "")
      .replace(/\{\{clubName\}\}/gi, record?.clubName || record?.name || "")
      .replace(/\{\{contactName\}\}/gi, record?.contactName || "")
      .replace(/\{\{senderName\}\}/gi, currentUser?.name || currentUser?.email || "")
      .replace(/\{\{firstName\}\}/gi, (record?.contactName || "").split(" ")[0] || "")
      .replace(/\{\{stage\}\}/gi, record?.stage || record?.status || "")
      .replace(/\{\{service\}\}/gi, record?.service || "")
      .replace(/\{\{email\}\}/gi, record?.email || "");

    const finalSubject = replace(subject);
    let finalBody = replace(bodyHtml);
    if (signature?.trim()) finalBody = (finalBody.trim() + "<br><br>" + signature.trim().replace(/\n/g, "<br>")).trim();

    const userId = window._supabaseAuthId;
    if (!userId) { showToast("Not authenticated", "error"); setSending(false); return; }

    const resp = await fetch("/api/gmail-send", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: userId,
        to,
        cc: cc || undefined,
        bcc: bcc || undefined,
        subject: finalSubject,
        body: finalBody,
        token: (() => { const t = typeof localStorage !== "undefined" ? localStorage.getItem("gmail-access-token") : null; return t && t !== "null" ? t : null; })()
      })
    });
    const data = await resp.json();
    if (!resp.ok) { showToast(data.error || "Failed to send email", "error"); setSending(false); return; }

    const activity = {
      id: Date.now(),
      type: "Email",
      date: new Date().toISOString(),
      notes: `Email sent to ${to}\nSubject: ${finalSubject}\n\n${bodyText}`,
      content: `Email sent to ${to}\nSubject: ${finalSubject}\n\n${bodyText}`,
      attachments
    };
    if (lead) {
      saveLeads(leads.map(l => sameId(l.id, lead.id) ? { ...l, activity: [...(l.activity || []), activity] } : l));
    } else if (client) {
      saveClients(clients.map(c => sameId(c.id, client.id) ? { ...c, activity: [...(c.activity || []), activity] } : c));
    }
    showToast("Email sent successfully!");
    onClose();
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={() => { if (showEmojiPicker) setShowEmojiPicker(false); }}>
      <div style={{ background: "#fff", borderRadius: 12, width: 640, maxWidth: "95vw", maxHeight: "92vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "18px 24px 14px", borderBottom: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h2 style={{ fontFamily: "Merriweather, serif", color: NAVY, margin: 0, fontSize: 18 }}>Compose Email</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: SLATE }}>×</button>
        </div>

        {/* Scrollable body */}
        <div style={{ flex: 1, overflowY: "auto", padding: "0 24px" }}>

          {/* To */}
          <div style={{ display: "flex", alignItems: "center", borderBottom: "1px solid #eee", padding: "10px 0" }}>
            <span style={{ fontSize: 13, color: SLATE, width: 48, flexShrink: 0 }}>To</span>
            <input style={{ flex: 1, border: "none", outline: "none", fontSize: 14, color: "#222" }} value={to} onChange={e => setTo(e.target.value)} placeholder="recipient@email.com" />
            <button onClick={() => setShowCcBcc(!showCcBcc)} type="button" style={{ background: "none", border: "none", fontSize: 12, color: SLATE, cursor: "pointer", padding: "2px 6px" }}>
              {showCcBcc ? "Hide" : "Cc Bcc"}
            </button>
          </div>

          {/* Cc / Bcc */}
          {showCcBcc && (
            <>
              <div style={{ display: "flex", alignItems: "center", borderBottom: "1px solid #eee", padding: "10px 0" }}>
                <span style={{ fontSize: 13, color: SLATE, width: 48, flexShrink: 0 }}>Cc</span>
                <input style={{ flex: 1, border: "none", outline: "none", fontSize: 14, color: "#222" }} value={cc} onChange={e => setCc(e.target.value)} placeholder="cc@email.com" />
              </div>
              <div style={{ display: "flex", alignItems: "center", borderBottom: "1px solid #eee", padding: "10px 0" }}>
                <span style={{ fontSize: 13, color: SLATE, width: 48, flexShrink: 0 }}>Bcc</span>
                <input style={{ flex: 1, border: "none", outline: "none", fontSize: 14, color: "#222" }} value={bcc} onChange={e => setBcc(e.target.value)} placeholder="bcc@email.com" />
              </div>
            </>
          )}

          {/* Subject */}
          <div style={{ display: "flex", alignItems: "center", borderBottom: "1px solid #eee", padding: "10px 0" }}>
            <span style={{ fontSize: 13, color: SLATE, width: 48, flexShrink: 0 }}>Subject</span>
            <input style={{ flex: 1, border: "none", outline: "none", fontSize: 14, color: "#222" }} value={subject} onChange={e => setSubject(e.target.value)} placeholder="Email subject" />
          </div>

          {/* Template selector */}
          {templates && templates.length > 0 && (
            <div style={{ padding: "10px 0", borderBottom: "1px solid #eee" }}>
              <select style={{ ...S.input, fontSize: 13, marginBottom: 0 }} value={selectedTemplate} onChange={e => {
                const t = templates.find(tm => tm.id === e.target.value);
                if (t) {
                  setSelectedTemplate(t.id);
                  setSubject(replaceVars(t.subject || "", record, currentUser));
                  if (editorRef.current) {
                    editorRef.current.innerHTML = replaceVars(t.body || "", record, currentUser).replace(/\n/g, "<br>");
                  }
                  setAttachments(t.attachments || []);
                } else {
                  setSelectedTemplate("");
                }
              }}>
                <option value="">— Load Template (optional) —</option>
                {templates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
          )}

          {/* Rich text toolbar */}
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, padding: "8px 0 6px", borderBottom: "1px solid #eee" }}>
            {/* Font family */}
            <select
              onMouseDown={() => { const sel = window.getSelection(); if (sel && sel.rangeCount > 0) savedSelectionRef.current = sel.getRangeAt(0).cloneRange(); }}
              onChange={e => { restoreSelection(); exec("fontName", e.target.value); editorRef.current?.focus(); }}
              style={{ fontSize: 12, border: "1px solid #ddd", borderRadius: 4, padding: "2px 4px", color: NAVY, height: 28, cursor: "pointer" }}>
              <option value="Arial">Arial</option>
              <option value="Georgia">Georgia</option>
              <option value="Times New Roman">Times New Roman</option>
              <option value="Courier New">Courier New</option>
              <option value="Verdana">Verdana</option>
              <option value="Merriweather">Merriweather</option>
              <option value="Open Sans">Open Sans</option>
            </select>

            {/* Font size */}
            <select
              onMouseDown={() => { const sel = window.getSelection(); if (sel && sel.rangeCount > 0) savedSelectionRef.current = sel.getRangeAt(0).cloneRange(); }}
              onChange={e => { restoreSelection(); exec("fontSize", e.target.value); editorRef.current?.focus(); }}
              style={{ fontSize: 12, border: "1px solid #ddd", borderRadius: 4, padding: "2px 4px", color: NAVY, height: 28, cursor: "pointer", marginLeft: 2 }}
              defaultValue="3">
              <option value="1">10</option>
              <option value="2">12</option>
              <option value="3">14</option>
              <option value="4">16</option>
              <option value="5">18</option>
              <option value="6">24</option>
              <option value="7">32</option>
            </select>

            <Divider />

            <ToolBtn cmd="bold" title="Bold"><b>B</b></ToolBtn>
            <ToolBtn cmd="italic" title="Italic"><i>I</i></ToolBtn>
            <ToolBtn cmd="underline" title="Underline"><u>U</u></ToolBtn>

            <Divider />

            {/* Text color */}
            <button
              type="button"
              title="Text color"
              onMouseDown={e => { e.preventDefault(); saveSelection(); colorInputRef.current?.click(); }}
              style={{ background: "none", border: "1px solid #ddd", borderRadius: 4, padding: "2px 6px", cursor: "pointer", height: 28, display: "flex", alignItems: "center", gap: 3, fontSize: 12, color: NAVY }}>
              A <span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: "#e53935" }} />
            </button>
            <input ref={colorInputRef} type="color" defaultValue="#e53935"
              onChange={e => { restoreSelection(); exec("foreColor", e.target.value); }}
              style={{ width: 0, height: 0, opacity: 0, position: "absolute" }} />

            <Divider />

            {/* Alignment */}
            <ToolBtn cmd="justifyLeft" title="Align left">≡</ToolBtn>
            <ToolBtn cmd="justifyCenter" title="Center">≡</ToolBtn>
            <ToolBtn cmd="justifyRight" title="Align right">≡</ToolBtn>

            <Divider />

            {/* Lists */}
            <ToolBtn cmd="insertUnorderedList" title="Bullet list">• ≡</ToolBtn>
            <ToolBtn cmd="insertOrderedList" title="Numbered list">1. ≡</ToolBtn>

            <Divider />

            {/* Indent / Outdent */}
            <ToolBtn cmd="outdent" title="Outdent">⇤</ToolBtn>
            <ToolBtn cmd="indent" title="Indent">⇥</ToolBtn>

            <Divider />

            {/* Link */}
            <ToolBtn title="Insert link" onClick={() => { saveSelection(); setShowLinkInput(true); }}>🔗</ToolBtn>

            {/* Emoji */}
            <div style={{ position: "relative" }}>
              <ToolBtn title="Insert emoji" onClick={() => { saveSelection(); setShowEmojiPicker(p => !p); }}>😊</ToolBtn>
              {showEmojiPicker && (
                <div style={{ position: "absolute", top: 32, left: 0, background: "#fff", border: "1px solid #ddd", borderRadius: 8, padding: 8, zIndex: 100, display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 4, boxShadow: "0 4px 16px rgba(0,0,0,0.15)" }}>
                  {EMOJIS.map(em => (
                    <button key={em} type="button" onMouseDown={e => { e.preventDefault(); insertEmoji(em); }}
                      style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", padding: 4, borderRadius: 4 }}>{em}</button>
                  ))}
                </div>
              )}
            </div>

            {/* File attach */}
            <ToolBtn title="Attach file" onClick={() => fileInputRef.current?.click()}>📎</ToolBtn>
            <input ref={fileInputRef} type="file" multiple style={{ display: "none" }} onChange={handleFileAttach} />
          </div>

          {/* Link input row */}
          {showLinkInput && (
            <div style={{ display: "flex", gap: 8, padding: "8px 0", borderBottom: "1px solid #eee", alignItems: "center" }}>
              <input style={{ ...S.input, flex: 1, marginBottom: 0, fontSize: 13 }} placeholder="Display text (optional)" value={linkText} onChange={e => setLinkText(e.target.value)} />
              <input style={{ ...S.input, flex: 2, marginBottom: 0, fontSize: 13 }} placeholder="https://..." value={linkUrl} onChange={e => setLinkUrl(e.target.value)} />
              <button type="button" onMouseDown={e => { e.preventDefault(); insertLink(); }} style={S.btnPrimary}>Add</button>
              <button type="button" onMouseDown={e => { e.preventDefault(); setShowLinkInput(false); }} style={S.btnGhost}>Cancel</button>
            </div>
          )}

          {/* Editor */}
          <div
            ref={editorRef}
            contentEditable
            suppressContentEditableWarning
            onBlur={saveSelection}
            style={{
              minHeight: 240,
              padding: "14px 0",
              outline: "none",
              fontSize: 14,
              lineHeight: 1.6,
              color: "#222",
              fontFamily: "Arial, sans-serif",
            }}
          />

          {/* Attachments */}
          {attachments.length > 0 && (
            <div style={{ borderTop: "1px solid #eee", paddingTop: 10, marginBottom: 8 }}>
              <AttachmentsPanel
                attachments={attachments}
                onAdd={(a) => setAttachments(prev => [...prev, a])}
                onDelete={(id) => setAttachments(prev => prev.filter(a => a.id !== id))}
              />
            </div>
          )}

          {/* AI Draft purpose */}
          <div style={{ borderTop: "1px solid #eee", padding: "12px 0 4px" }}>
            <input
              style={{ ...S.input, fontSize: 13, marginBottom: 0 }}
              value={purpose}
              onChange={e => setPurpose(e.target.value)}
              placeholder="✨ What is this email for? (helps AI draft — e.g. Follow up after tour, Renewal reminder...)"
            />
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "14px 24px", borderTop: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fafafa" }}>
          <button type="button" style={S.btnGold} onClick={draftWithAI} disabled={drafting}>
            {drafting ? "Drafting..." : "✨ AI Draft"}
          </button>
          <div style={{ display: "flex", gap: 10 }}>
            <button type="button" style={S.btnGhost} onClick={onClose}>Cancel</button>
            <button type="button" style={S.btnPrimary} onClick={send} disabled={sending}>
              {sending ? "Sending..." : "Send Email"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
